import React, { useEffect, useState } from "react";
import { Tabs } from "antd";
import Detail from "./Retreats/Detail";
import Documents from "./Retreats/Documents";
import LearningOutcomes from "./Retreats/LearningOutcomes";
import MenuFood from "../MenuFood/MenuFood";
import InteractiveWeeklySchedule from "../WeeklySchedule/WeeklySchedule";
import EvaluationForm from "./Retreats/EvaluationForm";
import Group from "./Retreats/Group";
import Certification from "../Certification/Certification";
import { useParams } from "react-router-dom";
import { GetretreatByID } from "../../api/AdminService";
// import ListOrder from "../../Components/OrderCard/ListOrder";
// import ListOrderFinished from "../../Components/OrderCard/ListOrderFinished";
// import ListOrderStorage from "./../../Components/OrderCard/ListOrderStorage";
// import ListOrderPending from "../../Components/OrderCard/ListOrderPending";
// import ListOrderAbandoned from "../../Components/OrderCard/ListOrderAbandoned";
// import ListOrderCanceled from "../../Components/OrderCard/ListOrderCanceled";
// import ListOrderShipping from "../../Components/OrderCard/ListOrderShipping";
// import ListOrderProcessing from "../../Components/OrderCard/ListOrderProcessing";
// import ListOrderApproved from "../../Components/OrderCard/ListOrderApproved";
// import ListOrderReceived from "../../Components/OrderCard/ListOrderReceived";
// import ListOrderDelivered from "../../Components/OrderCard/ListOrderDelivered";

const DetailRetreatsInformation = () => {
  const { id } = useParams();
  const [RetreatStatus, setRetreatStatus] = useState([]);
  const [activeKey, setActiveKey] = useState("1");
  const onChange = (key) => {
    console.log(key);
    setActiveKey(key);
  };
  const items = [
    {
      key: "1",
      label: "Detail",
      children: <Detail activeKey={activeKey} />,
    },
    {
      key: "2",
      label: "Documents",
      children: <Documents activeKey={activeKey} />,
    },
    {
      key: "3",
      label: "Learning Outcomes ",
      children: <LearningOutcomes activeKey={activeKey} />,
    },
    {
      key: "4",
      label: "Weekly Schedule",
      children: <InteractiveWeeklySchedule activeKey={activeKey} />,
    },
    {
      key: "5",
      label: "Menu Food",
      children: <MenuFood activeKey={activeKey} />,
    },
    {
      key: "6",
      label: "Evaluation Form",
      children: <EvaluationForm activeKey={activeKey} />,
    },

    {
      key: "7",
      label: "Group",
      children: <Group activeKey={activeKey} />,
    },
    ...(RetreatStatus === "InActive" ? [{
      key: "8",
      label: "Certification",
      children: <Certification activeKey={activeKey} />,
    }] : []),
    // {
    //   key: "8",
    //   label: "Đang vận chuyển",
    //   children: <ListOrderShipping activeKey={activeKey} />,
    // },
    // {
    //   key: "9",
    //   label: "Đã vận chuyển",
    //   children: <ListOrderDelivered activeKey={activeKey} />,
    // },
    // {
    //   key: "10",
    //   label: "Hoàn thành",
    //   children: <ListOrderFinished activeKey={activeKey} />,
    // },

    // {
    //   key: "11",
    //   label: "Quá hạn ",
    //   children: <ListOrderAbandoned activeKey={activeKey} />,
    // },
  ];

  const GetRetreatID = (id) => {
    console.log(id)
    GetretreatByID(id).then(res => {
        if (res.status === 200) {
            console.log(res.data.status)
            setRetreatStatus(res.data.status)
        }
    })
}

useEffect(() => {
  GetRetreatID(id);
}, []);

  return <Tabs defaultActiveKey="1" items={items} onChange={onChange} scrollable />;
};
export default DetailRetreatsInformation;
